import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'ps-design';

import './DataNugget.scss';

class DataNugget extends Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.any,
    dataTestId: PropTypes.string,
    labelTooltip: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.generateLabel = this.generateLabel.bind(this);
  }

  generateLabel() {
    if (this.props.labelTooltip) {
      return (
        <Tooltip
          hoverText={this.props.labelTooltip}
          tooltipText={this.props.label}
          display="underline"
          id={this.props.label}
        />
      );
    } else {
      return this.props.label;
    }
  }

  render() {
    return (
      <div className="data__nugget">
        <div className="data__nugget--label">{this.generateLabel()}</div>
        <div className="data__nugget--value">{this.props.value}</div>
      </div>
    );
  }
}

export default DataNugget;
